exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._29Sej {\n  color: #88733C;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n._29Sej h1 {\n  color: #88733C;\n  font-weight: bold;\n}\n._1lCAE {\n  max-width: 960px;\n}\n.T60sc {\n  padding: 20px 25px;\n  color: #fff;\n}\n", ""]);

// Exports
exports.locals = {
	"top": "_29Sej",
	"menu": "_1lCAE",
	"buildNumber": "T60sc"
};